module.exports = __webpack_public_path__ + "img/banner-2.1b82fe36.jpg";